import {Component, OnInit, ViewChild} from '@angular/core';
import {AuthenticationService} from '../../authentication/shared/authentication.service';
import {User} from '../../models/user';
import {CuiBaseComponent} from '@cicero/webui/lib/core/shared/base-component';
import {CuiSidenavComponent} from '@cicero/webui/lib/navigation/sidenav';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent extends CuiBaseComponent implements OnInit {
  user: User;

  @ViewChild(CuiSidenavComponent)
  sidenav: CuiSidenavComponent;

  constructor(private auth: AuthenticationService) {
    super();
  }

  ngOnInit() {
    const subscription = this.auth.user.subscribe(user => this.user = user);

    this.pushSubscription(subscription);
  }

  toggle() {
    this.sidenav.toggle();
  }

  open() {
    this.sidenav.open();
  }

  close() {
    this.sidenav.close();
  }

  logout() {
    this.auth.logout().subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/navigation/sidenav/sidenav.component.ts